import React, { useState } from "react";
import PropTypes from "prop-types";

const CustomInput = ({ name, label, value, required, disabled, onChange }) => {
  const [inputValue, setInputValue] = useState(value);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { value: v } = e.target;
    setInputValue(v);
    setError("");

    if (required && !v) {
      setError("This field is required");
    }

    onChange(name, v);
  };

  return (
    <div className="form-group">
      <label htmlFor={name}>
        {label} {required && "*"}
      </label>
      <input
        id={name}
        name={name}
        type="text"
        value={inputValue}
        onChange={handleChange}
        required={required}
        disabled={disabled}
        className={`form-control ${error ? "is-invalid" : ""}`}
      />
      {error && <div className="invalid-feedback">{error}</div>}
    </div>
  );
};

CustomInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired
};

CustomInput.defaultProps = {
  value: "",
  required: false,
  disabled: false
};

export default CustomInput;
